export const APP_LOCALSTORAGE_PREFIX_KEY =
  import.meta.env.VITE_APP_LOCALSTORAGE_PREFIX_KEY || 'admin_nutrisee_';
